<template>
    <div class="container">
        <router-view />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { routes } from './router';

export default defineComponent({
    name: 'App',
    data() {
        return {
            routes,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/main.scss';
</style>

<style lang="scss" scoped>
.app-header {
    margin: 2rem 0 4rem;

    @media (min-width: 768px) {
        display: flex;
        align-items: center;
    }
}

h1 {
    font-size: 1.2em;
    margin: 0 0 1rem;

    @media (min-width: 768px) {
        margin: 0 2rem 0 0;
    }
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li:not(&:last-of-type) {
        margin: 0 2rem 0 0;
        padding: 0;
    }

    @media (min-width: 768px) {
        display: flex;

        li {
            margin: 0 0 0.5rem;
        }
    }
}

a {
    text-decoration: none;
    color: #222;
    padding: 0.5rem;
    margin: 0 -0.5rem;
}

.router-link-exact-active {
    text-decoration: underline;
    font-weight: bold;
}
</style>
